var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "information",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#495057}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1061"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1060"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_760",
    cx: 0.977,
    cy: 0.977,
    r: 0.977,
    className: "cls-1",
    transform: "translate(9.023 13.809)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2418",
    d: "M10 0a10 10 0 1 0 10 10A9.995 9.995 0 0 0 10 0zm0 18.438A8.437 8.437 0 1 1 18.438 10 8.433 8.433 0 0 1 10 18.438z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2419",
    d: "M179.125 128.5a3.129 3.129 0 0 0-3.125 3.125.781.781 0 0 0 1.563 0 1.563 1.563 0 1 1 1.563 1.563.781.781 0 0 0-.781.781v1.953a.781.781 0 0 0 1.563 0v-1.271a3.125 3.125 0 0 0-.781-6.151z",
    className: "cls-1",
    transform: "translate(-169.125 -123.48)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInformation);
export default __webpack_public_path__ + "static/media/icon-information.ae5c1d5403fcf59e26f101a3100eefa4.svg";
export { ForwardRef as ReactComponent };